import React, { useState } from 'react';
import Icon from '../../../../../components/presentational/Icon';
import Spacer from '../../../../../components/presentational/Spacer';
import styled, { StylesProps } from '../../../../../lib/styles';

import summaryBlockStyles from './SummaryBlock_styles';

export interface SummaryBlockData {
  type: 'summary_block';
  heading: string;
  links: any;
}

const SummaryBlock = ({ block: { heading, links }, styles }) => {
  const renderSummaryGroup = (group, key) => {
    return (
      <div key={key} className={styles.summaryGroup}>
        <h4 className={styles.groupHeading}>{group.heading}</h4>
        <ul className={styles.links}>
          {group.links.map((link, index) => {
            return (
              <li key={index} className={styles.linkItem}>
                <Icon
                  icon="contact_support"
                  color="dark_grey"
                  className={styles.summaryIcon}
                />
                <a className={styles.link_url} href={link.link.url}>
                  {link.text}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <Spacer width={1160} space={['m', 'l']}>
        <div className={styles.panel}>
          <h2 className={styles.summaryHeading}>
            <b>{heading}</b>
          </h2>
          <div className={styles.groupContainer}>
            {links.map((group, i) => renderSummaryGroup(group, i))}
          </div>
        </div>
      </Spacer>
    </div>
  );
};

export default styled(summaryBlockStyles)(SummaryBlock);
